import React from 'react';
import EImg from './EImg';

const EAvo = ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="Developer Avocado"
		aria-label="Emoji: Avocado"
		alt="🥑"
		src="https://abs.twimg.com/emoji/v2/72x72/1f951.png"
	/>
);

export default EAvo;
